<template>
  <div id="basket-header">
    <img id="basket-icon" :src="basketIcon">
    <div id="selection-count">
      {{ basketCount }}
    </div>
  </div>
</template>

<script setup>
  import { storeToRefs } from "pinia";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";
  import basketIcon from '@/images/BasketIcon.svg'

  const searchPageStore = useSearchPageStore()
  const { basketCount } = storeToRefs(searchPageStore)
</script>

<!-- scoped? -->
<style lang="scss">
  #basket-header {
    position: relative;
  }

  #selection-count {
    position: absolute;
    bottom: 10px;
    left: 45px;
    font-weight: bold;

    background-color: $la-accent;
    color: white;
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 10pt;
  }

  #basket-icon {
    max-height: 35px;
    margin: 20px;
  }
</style>
